/**
 * 계정 배지 문구 — **판정은 한 곳에서.**
 *
 * "누구 계정으로 도는가" 는 실행 전에 보여야 한다. 로그인이 없으면 턴이 412 로 죽고, 구독
 * 대신 API 키로 돌면 종량으로 청구된다. 둘은 사용자에게 **다른 사실**이므로 "연결됨" 하나로
 * 뭉뚱그리지 않는다.
 *
 * 이 함수를 따로 뺀 이유: 배지를 그리는 곳이 둘이 됐다(에이전트 패널 제목 · 사례 등록 화면).
 * 각자 판정하면 같은 계정이 한쪽에서는 "로그인", 다른 쪽에서는 "없음" 으로 보이게 된다 —
 * 서버가 고른 경로(`account.source`)를 **그대로** 옮기는 것이 규칙이고, 그 규칙의 사본을
 * 만들지 않는다.
 *
 * @param {object|null} account  `/assistant/account` 응답. null 이면 아직 못 읽었다
 * @param {string} error         계정을 못 읽은 이유 (있으면 "실패", 없으면 "확인 중")
 * @returns {{ ok: boolean, label: string, tip: string }}
 */
export function describeAccount({ account, error }, t) {
    const P = (account && account.provider) || 'claude';
    const provider = P.charAt(0).toUpperCase() + P.slice(1);
    if (!account) {
        // **못 읽은 것과 읽는 중을 가른다.** 실패를 "확인 중" 으로 두면 영원히 확인 중처럼
        // 보인다 — 실제로 백엔드가 죽어 502 가 나던 동안 그렇게 보였다.
        if (error) {
            return { ok: false, label: t('assistant:panel.acct.failed'), tip: t('assistant:panel.acct.tipFailed', { error }) };
        }
        // 읽는 중은 **경고가 아니다.** 경고색으로 그리면 "계정이 없다" 로 읽힌다.
        return { ok: true, label: t('assistant:panel.acct.checking'), tip: t('assistant:panel.acct.tipChecking') };
    }
    if (account.blockedSource) {
        return { ok: false, label: t('assistant:panel.acct.blocked'), tip: t('assistant:panel.acct.tipBlocked') };
    }
    const src = account.mode === 'standalone'
        ? (account.loggedIn ? 'local' : 'none')
        : (account.source || 'none');
    if (src === 'none') {
        return { ok: false, label: t('assistant:panel.acct.none'), tip: t('assistant:panel.acct.tipNone') };
    }
    const how = t(`assistant:panel.acct.${src}`);
    // 어느 계정인지까지 — 로그인은 이메일, 토큰·키는 앞뒤만 남긴 힌트다(값은 서버가 안 준다)
    const who = account.email || (src === 'apiKey' ? account.apiKeyHint : account.hint) || '';
    return {
        ok: true,
        label: `${provider} · ${how}`,
        tip: [t('assistant:panel.acct.tip', { provider, how }),
            who ? t('assistant:panel.acct.as', { email: who }) : ''].filter(Boolean).join(' '),
    };
}

export default describeAccount;
